<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses"/>

    <!--  show event prompt  -->
    <custom-event ref="event"
                  :event-data="newEvents[0]"
                  @seen="showEvent(true)"/>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import themeConfig from '@/../themeConfig.js'
import CustomEvent from './components/customEvent/customEvent'
import updateApp from './mixins/update'

export default {
  components: {CustomEvent},
  metaInfo: {
    titleTemplate: (titleChunk) => {
      const base_title = JSON.parse(localStorage.getItem('clubInfo')) ? JSON.parse(localStorage.getItem('clubInfo')).club_name : 'یوزرال | Useral'
      return titleChunk ? `${titleChunk} | ${base_title}` : base_title
    },
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no' }
    ],
  },
  mixins: [updateApp],
  data () {
    return {
      vueAppClasses: [],
      pageHaveChanges: false,
      newEvents: []
    }
  },
  watch: {
    updateExists: {
      handler (val) {
        if (val) {
          this.refreshApp()
        }
      }
    },
    '$store.state.pageHaveChanges' () {
      /*if (val) {
        window.addEventListener('beforeunload', function (e) {
          e.preventDefault();
          e.returnValue = '';
        });
      } else {
        window.removeEventListener('beforeunload', function (e) {
          e.preventDefault();
          e.returnValue = '';
        });
      }*/
    },
    '$store.state.auth.user': {
      handler (val) {
        if (val.events && val.events.length > 0) {
          this.newEvents = JSON.parse(JSON.stringify(val.events))
          this.showEvent()
        }
      },
      deep: true
    },
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    },
    '$route' () {
      if (localStorage.getItem('expired_at') && (new Date().getTime()) / 1000 > localStorage.getItem('expired_at')) {
        this.$store.dispatch('auth/logout')
        this.$vs.notify({
          title: this.$t('login.notification.forceLogout.title'),
          text: this.$t('login.notification.forceLogout.message'),
          color: 'danger',
          icon: 'icon-log-out',
          iconPack: 'feather',
          time: 2400
        })
      }
    }
  },
  methods: {
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        if (document.body.className.match('theme-sea')) document.body.classList.remove('theme-sea')
        if (document.body.className.match('theme-flamingo')) document.body.classList.remove('theme-flamingo')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-sea')) document.body.classList.remove('theme-sea')
        if (document.body.className.match('theme-flamingo')) document.body.classList.remove('theme-flamingo')
        document.body.classList.add('theme-semi-dark')
      } else if (className === 'sea') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        if (document.body.className.match('theme-flamingo')) document.body.classList.remove('theme-flamingo')
        document.body.classList.add('theme-sea')
      } else if (className === 'flamingo') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        if (document.body.className.match('theme-sea')) document.body.classList.remove('theme-sea')
        document.body.classList.add('theme-flamingo')
      } else {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        if (document.body.className.match('theme-sea')) document.body.classList.remove('theme-sea')
        if (document.body.className.match('theme-flamingo')) document.body.classList.remove('theme-flamingo')
        document.body.classList.add('theme-light')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    showEvent (remove = false) {
      setTimeout(() => {
        if (remove) this.newEvents.splice(0, 1)

        if (this.newEvents.length > 0 && this.$refs.event) this.$refs.event.showEvent()
      }, 500)
    },
    uninstallServiceWorker () {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          for (const registration of registrations) {
            // unregister service worker
            console.log('serviceWorker unregistered');
            registration.unregister();
          }
        });
      }
    }
  },
  mounted () {
    //  set current theme
    let theme = {
        value: '',
        sendServer: false
    }
    theme.value = localStorage.getItem('theme')
    if (theme.value) {
      this.$store.dispatch('updateTheme', theme)
    }

    this.uninstallServiceWorker()

    // set current locale
    this.$i18n.locale = this.locale
    if (this.locale === 'en') {
      this.$vs.rtl = false
    } else if (this.locale === 'fa') {
      this.$vs.rtl = true
    }
    // /set current locale

    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  computed: {
    ...mapGetters({
      locale: 'currentLocale',
      clubInfo: 'setting/getClubInfo'
    })
  },
  async created () {
    Vue.prototype.$vs = this.$vs
    Vue.prototype.noAccessNotify = {
      title: this.$t('alert.error.title'),
      text: this.$t('alert.error.accessDenied')
    }
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    /*let activeUser = this.$store.state.auth.user
    if (activeUser) {
      // get data from pusher
      if (!window.Echo.connector.pusher.config.auth.headers['Authorization'])
        window.Echo.connector.pusher.config.auth.headers['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`;
      window.Echo.private("employee-notif").listen(".all", (e) => {
        if (e.message) {
          this.$vs.notify({
            title: 'پیام',
            text: e.message,
            time: 5000,
            icon: 'icon-message-circle',
            iconPack: 'feather'
          })
        } else {
          console.log(e);
        }
      });
    }*/
  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>

<style lang="scss">
.vs-sidebar {
  /*background-color: #1976d2 !important;*/
}
</style>
